export default "__VITE_ASSET__DJYD7rp5__"